import { get } from "../helpers/config";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

export const useFetchSites = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("sites/list");
    }, options);
};